import(/* webpackMode: "eager", webpackExports: ["EulaContent"] */ "/home/runner/work/breedlogic-frontend-api/breedlogic-frontend-api/breedlogic-web/src/components/TermsAndConditionsDialog/EulaContent.tsx");
